import { SGeneralForms, SLocalTreeSelected } from 'shj-components'
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { Button, Input, message, Select, TreeSelect } from 'antd'
import { httpOrgList } from '@/services/homeService.ts'
import { getProductCommonPage, getSkuPageList } from '@/services/product.ts'
import { debounce, isEmpty } from 'lodash-es'
import { useSetState } from 'ahooks'
import { replaceRule, trimStr } from '@/utils/data.ts'
import DebounceSearchSelect from '@/pages/baseProduct/components/DebounceSearchSelect'
import RulesModal from '@/pages/baseProduct/components/RuleModal/RulesModal.tsx'
import dayjs from 'dayjs'
import DebounceSelect from '@/pages/baseProduct/components/DebounceSearchSelect'

type IProps = {
  record: Record<string, any>
  chooseTypeKey?: string
  genItemId?: string
  fn: (data: Record<string, any>) => void
  setLoading: (flag: boolean) => void
  readOnly?: boolean
}

export const AddOrEditStandard = forwardRef((props: IProps, ref) => {
  const formRef = useRef()

  const [state, setState] = useSetState<any>({
    initValues: {},
    companyList: [],
    productList: [],
    budgetRule: '',
    searchValue: '',
  })

  const [ruleModal, setRuleModal] = useSetState({
    open: false,
    mode: 'modal',
    value: '',
  })

  const onFormRef = () => {
    const { onFormRef } = formRef.current || {}
    return onFormRef?.()
  }

  useEffect(() => {
    getOptions()
    if (!isEmpty(props.record)) {
      console.log(props.record, 111111111)

      const { orgIdList: shops, budgetRule } = props.record.standardJson || {}
      const obj = {
        ...props.record,
        // editFlag:  props.record.editFlag,
        shops: shops?.map(item => item.id) || [],
        budgetRule: budgetRule,
        startDate: dayjs(props.record.startDate),
        endDate: props.record.endDate && dayjs(props.record.endDate),
        applyProdIdList: [props?.record?.applyProdId],
      }
      setRuleModal({ value: budgetRule })
      onFormRef()?.setFieldsValue(obj)
      setState({ initValues: { ...obj, shops } })
    }
  }, [props.record])

  useEffect(() => {
    getProduct(state.searchValue)
  }, [state.searchValue])

  const getProduct = debounce(async (nameKey?) => {
    const data: any = await getSkuPageList({
      pageId: 1,
      pageSize: 10,
      data: {
        skuNameKey: '', //sku名称检索
        busType: 'prod', //必传-对应产品还是打包模版的sku，该处默认传-prod
      },
    })
    setState({
      productList:
        data?.list.map(el => {
          return { skuName: el.id + '_' + el.skuName, id: el.id }
        }) || [],
    })
  }, 500)

  const getOptions = async () => {
    const companyList: any = await httpOrgList()
    setState({ companyList })
  }

  const getShopArr = codeArr => {
    return [{ id: '0', name: '通用' }, ...state.companyList]?.reduce((res, item) => {
      if (codeArr.includes(item.id)) res.push({ id: item.id, name: item.name })
      return res
    }, [])
  }

  const onFinish = () => {
    onFormRef()
      ?.validateFields()
      .then(values => {
        props.setLoading?.(true)
        const orgIdList = values.orgIdList ? getShopArr(values.orgIdList) : []
        const values_ = {
          ...values,
          standardJson: { orgIdList: orgIdList, budgetRule: ruleModal.value },
          genItemId: props.genItemId,
          startDate: values.startDate && dayjs(values.startDate).format('YYYY-MM-DD'),
          endDate: values.endDate && dayjs(values.endDate).format('YYYY-MM-DD'),
          applyProdId: props.record.applyProdId ? props.record.applyProdId : null,
        }
        if (props.genItemId) {
          props.fn?.(values_)
        } else {
          props.fn?.({ ...values_, key: values.key || +new Date() })
          props.setLoading?.(false)
        }
      })
  }

  useImperativeHandle(ref, () => {
    return {
      onFinish,
    }
  }, [onFinish])

  return (
    <>
      <SGeneralForms
        ref={formRef}
        isHideGobackBtn={true}
        isDetail={props.readOnly}
        initialValues={
          props.record.id
            ? {}
            : { requiredFlag: false, editFlag: false, applyProdIdList: ['0'], orgIdList: ['0'] }
        }
        layout={'vertical'}
        titleMode={props.readOnly ? '' : 'edit'}
        configs={[
          {
            title: '基础信息',
            formItem: [
              { name: 'id', hidden: true },
              { name: 'key', hidden: true },
              { name: 'genItemId', hidden: true },
              {
                name: 'requiredFlag',
                label: '是否必选',
                spanCol: 24,
                type: 'switch',
                comConfig: {
                  checkedChildren: '是',
                  unCheckedChildren: '否',
                },
              },
              {
                name: 'productSkuId',
                label: '选择产品SKU',
                required: !props.readOnly,
                rules: [{ required: true, message: '产品SKU不能为空' }],
                spanCol: 24,
                children: (
                  <DebounceSearchSelect
                    readOnly={props.readOnly}
                    fetchOptions={getSkuPageList}
                    label={'产品SKU'}
                    nameKey={'keyword'}
                    disabled={props.record?.id}
                    fixedParams={{
                      prodTypes: ['PRODUCT_SINGLE', 'PRODUCT_GROUP', 'PRODUCT_BASIC_ITEM'],
                    }}
                    fieldNames={{ label: 'showName', value: 'id' }}
                    query={{ id: state.initValues.productSkuId }}
                  />
                ),
              },
            ],
          },
          {
            title: '预算量规则',
            titleMode: 'drawer',
            formItem: [
              {
                label: '预算量规则',
                spanCol: 24,
                [props.readOnly ? 'name' : '']: 'budgetRule',
                [props.readOnly ? '' : 'children']: (
                  <div>
                    <Button onClick={() => setRuleModal({ open: true })}>编辑规则</Button>
                    {ruleModal?.value && (
                      <Input.TextArea
                        autoSize={{ minRows: 1, maxRows: 4 }}
                        disabled
                        style={{ marginTop: 6 }}
                        value={replaceRule(ruleModal.value)}
                      />
                    )}
                  </div>
                ),
              },
              {
                name: 'editFlag',
                label: '是否可编辑量',
                spanCol: 24,
                type: 'switch',
                comConfig: {
                  checkedChildren: '是',
                  unCheckedChildren: '否',
                },
              },
            ],
          },
          {
            title: '适用渠道',
            titleMode: 'drawer',
            formItem: [
              {
                spanCol: 24,
                label: '适用产品',
                name: 'applyProdIdList',
                required: true,
                // isDeps: true,
                // deps: () => !props.record?.id,
                rules: [{ required: true, message: '适用产品不能为空' }],
                children: (
                  <DebounceSelect
                    disabled={props.record?.id}
                    allowClear
                    label={'产品'}
                    isCommon={true}
                    mode={'multiple'}
                    fixedParams={{ prodType: 'PRODUCT_PACKAGE' }}
                    fetchOptions={getProductCommonPage}
                    fieldNames={{ label: 'prodName', value: 'id' }}
                    query={{id: state?.initValues?.applyProdId}}
                  />
                ),
              },
              {
                name: props.record?.id ? 'orgId' : 'orgIdList',
                label: '适用门店',
                spanCol: 24,
                required: true,
                children: props.readOnly ? (
                  <div>{state.initValues.orgName}</div>
                ) : (
                  <SLocalTreeSelected
                    treeCheckable
                    disabled={props.record?.id}
                    treeDefaultExpandAll
                    showCheckedStrategy={TreeSelect.SHOW_PARENT}
                    fieldNames={{ label: 'name', value: 'id' }}
                    treeData={[{ name: '通用', id: '0' }, ...state.companyList]}
                  />
                ),
              },
              {
                spanCol: 24,
                label: '开始日期',
                name: 'startDate',
                required: true,
                rules: [{ required: true, message: '开始日期不能为空' }],
                type: 'date',
              },
              {
                spanCol: 24,
                label: '结束日期',
                name: 'endDate',
                type: 'date',
                comConfig: {
                  disabledDate: current => {
                    const startDate = onFormRef().getFieldValue('startDate')
                    if (startDate) return current && current < dayjs(startDate).endOf('day')
                  },
                },
              },
            ],
          },
        ]}
      />
      <RulesModal
        modalProps={{ ...ruleModal }}
        onCancel={() => setRuleModal({ open: false })}
        type={'generalBudgetItem'}
        onOk={(value: string) => setRuleModal({ value })}
      />
    </>
  )
})
